import gql from 'graphql-tag';

export const APPLY_CHARGES = gql`
  mutation ApplyChargesToInvoice($input: ApplyChargesToInvoiceInput!) {
    result: applyChargesToInvoice(input: $input) {
      error
      success
      entity {
        chargesTemplates {
          id
          name
          charges {
            data {
              name
              type
              amount
              isTaxable
              amountType
              equipmentId
              description
            }
          }

          dealRules {
            location
            customer
            equipment
          }
        }

        calculationResult {
          total
          taxTotal
          basePrice
          totalCharges
          taxableChargesTotal
          nonTaxableChargesTotal
          breakdown {
            type
            name
            amount
          }
        }

        dealRules
      }
    }
  }
`;
